<script lang="ts" setup>
import ScrollChapterAdGpt from './ScrollChapterAdGpt.vue'
import ScrollChapterAdSense from './ScrollChapterAdSense.vue'
import { brandConfig } from '@/config/brands'

const props = defineProps<{
  adSlotIndex: number
  adInstanceId: string
  adOrder: number
  chapterId: string
}>()

const AdComponent = brandConfig.adSense ? ScrollChapterAdSense : ScrollChapterAdGpt
</script>

<template>
  <component :is="AdComponent" v-bind="props" />
</template>
